import { TRUSTED_SENDER_STATUS_NOT_CONFIRMED } from 'Api/beSendGoApi'

import fetchStatus from './fetchStatus'

import mapStatusToVariant from './mapStatusToVariant'

const POLLING_INTERVAL = 5000

async function statusPolling(email, setter, t) {
  const statusResult = await fetchStatus(email)

  setter(prev => ({
    ...prev,
    variant: mapStatusToVariant(
      statusResult,
      false.Status,
      statusResult.ApplyOverrideDomain
    ),
    status: statusResult.Status
  }))

  if (statusResult.Status === TRUSTED_SENDER_STATUS_NOT_CONFIRMED) {
    const currentTimer = setTimeout(
      statusPolling,
      POLLING_INTERVAL,
      email,
      setter
    )
    setter(prev => ({
      ...prev,
      currentTimer
    }))
    return currentTimer
  }
}

export default statusPolling
